import AnimatedContent from "@components/AnimatedContent"
import Button from "@components/Button"
import Layout from "@components/Layout"
import { ReactNode } from "react"
import { useTranslation } from "react-i18next"
import { Form } from "react-router-dom"

interface ContinuePageBaseProps {
  translationKey: string
}

interface ContinuePageWithEmoji extends ContinuePageBaseProps {
  emoji: string
  children?: never
}

interface ContinuePageWithChildren extends ContinuePageBaseProps {
  emoji?: never
  children: ReactNode
}

type ContinuePageProps = ContinuePageWithEmoji | ContinuePageWithChildren

export default function ContinuePage({
  emoji,
  translationKey,
  children,
}: ContinuePageProps) {
  const { t } = useTranslation()

  return (
    <Layout>
      {emoji ? (
        <AnimatedContent
          emoji={emoji}
          heading={t(`pages.onboarding.${translationKey}.heading`)}
          description={t(`pages.onboarding.${translationKey}.description`)}
        />
      ) : (
        children
      )}

      <div className="shrink-0">
        <Form className="custom-form" method="post">
          <input
            name={t(`pages.onboarding.${translationKey}.heading`, {
              lng: "en",
            })}
            type="hidden"
            value={t("shared.continue", { lng: "en" })}
          />
          <Button title={t("shared.continue")} type="submit" arrow />
        </Form>
      </div>
    </Layout>
  )
}
